export default function UseMobile(){
    return(
        <div className="useMobile">
            <h1>Please use your mobile phone</h1>
        </div>
    )
}